var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWppIconColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2EC04F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5155_105621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.5001L11.875 22.3334C10.8231 20.8401 10.3522 19.0143 10.5509 17.1985C10.7495 15.3827 11.604 13.7019 12.9539 12.4714C14.3039 11.2408 16.0565 10.5453 17.8828 10.5152C19.7092 10.4851 21.4837 11.1225 22.8735 12.3079C24.2632 13.4933 25.1726 15.1451 25.431 16.9533C25.6893 18.7616 25.2789 20.6019 24.2768 22.1291C23.2746 23.6562 21.7495 24.7651 19.9878 25.2477C18.2261 25.7303 16.3489 25.5533 14.7083 24.7501L10.5 25.5001",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.3335C15.5 16.444 15.5439 16.55 15.622 16.6281C15.7002 16.7063 15.8062 16.7502 15.9167 16.7502C16.0272 16.7502 16.1332 16.7063 16.2113 16.6281C16.2894 16.55 16.3333 16.444 16.3333 16.3335V15.5002C16.3333 15.3897 16.2894 15.2837 16.2113 15.2055C16.1332 15.1274 16.0272 15.0835 15.9167 15.0835C15.8062 15.0835 15.7002 15.1274 15.622 15.2055C15.5439 15.2837 15.5 15.3897 15.5 15.5002V16.3335ZM15.5 16.3335C15.5 17.4386 15.939 18.4984 16.7204 19.2798C17.5018 20.0612 18.5616 20.5002 19.6667 20.5002M19.6667 20.5002H20.5C20.6105 20.5002 20.7165 20.4563 20.7946 20.3781C20.8728 20.3 20.9167 20.194 20.9167 20.0835C20.9167 19.973 20.8728 19.867 20.7946 19.7889C20.7165 19.7107 20.6105 19.6668 20.5 19.6668H19.6667C19.5562 19.6668 19.4502 19.7107 19.372 19.7889C19.2939 19.867 19.25 19.973 19.25 20.0835C19.25 20.194 19.2939 20.3 19.372 20.3781C19.4502 20.4563 19.5562 20.5002 19.6667 20.5002Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5155_105621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWppIconColor);
export default __webpack_public_path__ + "static/media/wppIconColor.e55bcf3a6aa0f8b9be439fe8db177823.svg";
export { ForwardRef as ReactComponent };